<template>
  <div>
    <v-tabs v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab class="tab-default" :key="1"> Học sinh</v-tab>
      <v-tab class="tab-default" :key="2"> Giáo viên </v-tab>
    </v-tabs>

    <v-card :flat="$vuetify.breakpoint.smAndDown">
      <v-tabs-items v-model="tab">
        <v-tab-item :key="1">
          <v-card>
            <div class="d-flex justify-end align-end mr-2">
              <v-btn
                v-if="$vuetify.breakpoint.mdAndUp"
                class="mt-4 mr-4"
                outlined
                color="success"
                @click="exportExcel('STUDENT_TABLE')"
              >
                <v-icon left>mdi-file-excel</v-icon> Xuất Excel
              </v-btn>
              <v-btn
                v-if="$auth.policies['add-student-extraClass']"
                depressed
                dark
                color="#0D47A1"
                @click.stop="createState = !createState"
              >
                <v-icon left>add</v-icon>Thêm học sinh
              </v-btn>
            </div>
            <StudentTable disableSort mobile-breakpoint="0" ref="studentTable" :propHeaders="headers" />
          </v-card>
        </v-tab-item>
        <v-tab-item :key="2">
          <div>
            <div class="d-flex justify-end align-end mt-6 mr-6">
              <v-btn depressed dark color="#0D47A1" @click.stop="createTeacher = !createTeacher">
                <v-icon left>add</v-icon>Giáo viên phụ trách
              </v-btn>
            </div>

            <v-card outlined class="ma-6 pa-6">
              <h4 class="mb-6">Giáo viên / người phụ trách</h4>
              <CardOwnClassTeacherInfo
                v-for="(item, index) in teachings"
                :ownClassTeacher="item.teacher"
                :key="index"
              />
            </v-card>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <ExtraClassAddStudentDialog :state="createState" />
    <ExtraTeachingNewDialog :state="createTeacher" :defaultClass="classData" @done="refresh" />
  </div>
</template>

<script>
import StudentTable from '@/modules/class/student/StudentTable.vue'
import CardOwnClassTeacherInfo from '@/components/basic/card/CardOwnClassTeacherInfo.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import utils from '@/plugins/utils'
import ExtraClassAddStudentDialog from '@/modules/class/ExtraClassAddStudentDialog.vue'
import ExtraTeachingNewDialog from '@/modules/teacher/ExtraTeachingNewDialog.vue'

export default {
  data() {
    return {
      createTeacher: false,
      tab: null,
      createState: false,
      headers: [
        { text: 'STT', value: 'index', align: 'center', sortable: false },
        { text: 'Học sinh', value: 'name', align: 'left', sortable: false },
        { text: 'Ngày sinh', value: 'dob', align: 'left', sortable: false },
        { text: 'Giới tính', value: 'gender', align: 'left', sortable: false },
        {
          text: 'Trạng thái',
          value: 'status',
          align: 'left',
          sortable: false
        },
        // {
        //   text: 'Lớp',
        //   value: 'currentClass',
        //   align: 'left',
        //   sortable: false,
        //   show: true
        // },
        {
          text: 'Thao tác',
          value: 'action',
          align: 'left',
          sortable: false,
          show: true
        }
      ]
    }
  },
  components: {
    CardOwnClassTeacherInfo,
    StudentTable,
    ExtraClassAddStudentDialog,
    ExtraTeachingNewDialog
  },
  methods: {
    ...mapActions('classDetail', ['fetchTeachings']),
    async refresh() {
      await this.fetchTeachings({
        class: this.classData.id
      })
    },
    exportExcel(tableName) {
      this.$loading.active = true
      const filters = this.$options.filters
      let excelHeader, fileName, data
      switch (tableName) {
        case 'STUDENT_TABLE':
          let studentHeaders = [...this.$refs.studentTable.headers]
          studentHeaders.shift()
          studentHeaders.splice(-1)
          studentHeaders.splice(1, 0, {
            text: 'Mã số',
            value: 'code'
          })
          excelHeader = studentHeaders.map(({ text, value }) => ({ text, value }))
          const students = JSON.parse(JSON.stringify(this.students))
          data = students.map(item => {
            item.code = filters.getStudentCode(item.code)
            item.status = filters.status(item.status)
            item.dob = filters.ddmmyyyy(item.dob)
            item.gender = filters.gender(item.gender)
            return item
          })
          fileName = `DanhSachHocSinh_${this.classData.title}`
          break
        case 'PARENT_TABLE':
          excelHeader = this.$refs.parentDataTable.headers.map(({ text, value }) => ({ text, value }))
          fileName = 'Parent_List'
          break
        case 'TEACHER_TABLE':
          excelHeader = this.$refs.teacherTable.headers.map(({ text, value }) => ({ text, value }))
          data = this.teachings
          fileName = 'Teacher_List'
      }
      utils.exportExcel(data, excelHeader, fileName)
      this.$loading.active = false
    }
  },
  computed: {
    ...mapGetters('classDetail', ['students', 'classData']),
    ...mapState('classDetail', ['teachings'])
  }
}
</script>

<style></style>
